/**
     * @desc 参会设备取消申请开麦
可能产生业务错误码：510001、510002、511001
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 云信会议房间ID */
  channelId?: number;
  /** 取消的申请token */
  requestToken?: string;
}

export const method = 'DELETE';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/v3/meeting/control/mike/on-request/cancel',
      params,
      'DELETE',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/control/mike/on-request/cancel',
    params,
    swrOptions,
    { method: 'DELETE' },
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/v3/meeting/control/mike/on-request/cancel',
      params,
      'DELETE',
    ),
    {
      method: 'DELETE',

      ...options,
    },
  );
}
